import EmployeePageWrapper from './EmployeePageWrapper';

export default EmployeePageWrapper;
